import { CustomValidatorOptions } from "../../models/form.models";
import { getElementByTableField } from "../forms.utility";

/** Static utility namespace for programmatically adding and removing ASP.NET custom validators on iMIS form-builder fields. */
export class CustomValidatorsUtility {
    /**
     * Creates and wires up a custom validator span for a form field, registering it with the page's Telerik/ASP.NET validation engine (`Page_Validators`) so it participates in form submission validation.
     * @param fieldName The name of the field as it appears in the target element's id.
     * @param validatorOptions Options describing the validator, including its id, error text, and evaluation function. Defaults are merged in for `validationGroup` ("FB_ValidationGroup") and `triggerValidation` (true) when not provided.
     * @param tableName The name of the table the field belongs to, used to locate the target element.
     */
    public static addValidator(fieldName, validatorOptions: CustomValidatorOptions, tableName) {
        let validatorOptionsWithDefaults: CustomValidatorOptions = Object.assign({}, { validationGroup: "FB_ValidationGroup", triggerValidation: true }, validatorOptions);

        let jControlToValidate = jQuery(getElementByTableField(fieldName, tableName));
        if (jControlToValidate.length > 0) {
            let jParentWrapper = jControlToValidate.parent();

            // setup validator
            let jValidator = jQuery("<span class='ValidationError' style='color: red; display: none;'></span>");
            jValidator.attr("id", validatorOptionsWithDefaults.id);
            jValidator.text(validatorOptionsWithDefaults.text);

            let validator = jValidator.get(0);
            validator["controltovalidate"] = jControlToValidate.attr("id");
            // a dynamic value ensures it adds/removes the span using the display css field
            validator["display"] = "Dynamic";
            validator["evaluationfunction"] = validatorOptionsWithDefaults.evaluationFunction;
            validator["validationGroup"] = validatorOptionsWithDefaults.validationGroup;
            // important to set the initial value if not already set
            validator["initialvalue"] = validator["initialvalue"] || "";

            jValidator.insertAfter(jParentWrapper);

            // validates on submission
            window.Page_Validators.push(validator);
            // sets up validator hook up with its associated control
            window.ValidatorOnLoad();

            if (validatorOptionsWithDefaults.triggerValidation) {
                // trigger validation on addition of custom validator
                window.ValidatorValidate(validator);
            }
        }
    }

    /**
     * Removes a previously added custom validator by id, detaching it from its target control's `Validators` list and from the page's `Page_Validators` list, then re-runs the field's change handler so it is re-validated without the removed validator.
     * @param validatorId The id of the validator element to remove.
     */
    public static removeValidator(validatorId) {
        let jValidator = jQuery("#" + validatorId);
        if (jValidator.length > 0) {
            let validator = jValidator.get(0);
            const getFilteredValidators = (validatorList: HTMLElement[]) => {
                let newValidatorList = [];
                validatorList.forEach((fieldValidator: HTMLElement) => {
                    if (fieldValidator.id != validator.id) {
                        newValidatorList.push(fieldValidator);
                    }
                });

                return newValidatorList;
            };

            // remove validator from control
            let jControlToValidate = jQuery("#" + validator["controltovalidate"]);
            let controlToValidate = jControlToValidate.get(0);
            controlToValidate["Validators"] = getFilteredValidators(controlToValidate["Validators"]);

            // remove validator from form submission validators
            window.Page_Validators = getFilteredValidators(window.Page_Validators);

            // invoke change event to validate field again after removing validator (the original one fires the event regardless of change)
            jValidator.remove();
            window.ValidatorOnChange_Original({ target: controlToValidate });
        }
    }
}